import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, ListGroupItemHeading } from 'reactstrap';
import PropTypes from 'prop-types';
import { chain } from 'lodash';

const AllergyDetail = ({ data }) => {
  const [allergens, setAllergens] = useState([]);

  useEffect(() => {
    if (data && data.length) {
      const uniqedAllergies = chain(data)
        .map(d => d.attributes.allergen)
        .uniq()
        .sort()
        .map(a => {
          const list = data.filter(d => d.attributes.allergen === a);

          return {
            allergen: a,
            sources: list,
          };
        })
        .value();

      setAllergens(uniqedAllergies);
    }
  }, [data]);

  return (
    <ListGroup>
      {allergens.map(a => (
        <ListGroupItem>
          <ListGroupItemHeading>{a.allergen}</ListGroupItemHeading>

          via {a.sources.map(l => l.attributes.sourceDescription)}
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

AllergyDetail.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    attributes: PropTypes.shape(),
  })).isRequired,
};

export default AllergyDetail;
